import { Component } from '@angular/core';
import {Camera} from '../camera/camera';

@Component({
  selector: 'app-home',
  imports: [Camera],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {

}
